// shared map UI state
export interface MapState {
  cvButtonActive: boolean, // has to be here until default markers are Store selectors
  markersMinimized: boolean, // has to be here until default markers are Store selectors
  // controls the visibility of street view panorama container
  streetViewActive: boolean, // could be moved to cv map signal store
  streetViewClosedByUser: boolean, // could be moved to cv map signal store
  showValidationHistory: boolean
}

// Initial State

export const initialState: MapState = {
  cvButtonActive: false,
  markersMinimized: false,
  streetViewActive: false,
  streetViewClosedByUser: false,
  showValidationHistory: false,
};
